import defaultState from './default';
import disabled from './disabled';
import focus from './focus';
import error from './error';

export default {
  default: defaultState,
  disabled,
  focus,
  error,
};
